/**
 * Defines the structure of an Environment Sound object.
 */
export interface iEnvSound {
    env_sound_id: number;
    env_sound_name: string | null;
    env_sound: string | null;
    env_start_beacon_id: string | null;    
    env_loop: number | null;
    created_at: string | null;
    updated_at: string | null;
}

export class EnvSoundModel implements iEnvSound{
    env_sound_id: number = 0;
    env_sound_name: string | null = null;
    env_sound: string | null = null;
    env_start_beacon_id: string | null = null;    
    env_loop: number | null = null;
    created_at: string | null = null;
    updated_at: string | null = null;

    constructor(options?: iEnvSound) {
        Object.assign(this, options);
    }

}